export enum APP_PAGES {
  SEARCH = "/",
  CUSTOMER_DETAILS = "/:name",
  RESOURCES = "/resources",
  CUSTOMERS_HOME = "/customers",
  // Document routes
  DOCS = "/documents",
  DOCS_LIBRARY = "/documents/library",
  DOCS_UPLOAD = "/documents/upload",
  DOCS_DETAIL = "/documents/doc/:id",
}

/** Paths that belong to the documents experience (not customer search). */
export const isDocsPath = (pathname: string): boolean =>
  pathname === APP_PAGES.DOCS || pathname.startsWith(`${APP_PAGES.DOCS}/`);
